module.exports = __webpack_public_path__ + "img/bank-islam-img.a4ea875a.png";